import React, { useState } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './styles.scss';
import RaterInputForm from './RaterInputForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getMasterRater } from '../../services/masterRater';
import { useHistory, useParams } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import { postRaterForm } from '../../services/raterForm';
import { showNotification } from '../../utilities/mantineNotification';

const AdminRaterFormInputPage = (props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [dataPayload, setDataPayload] = useState(null);

  const history = useHistory();
  const params: any = useParams();
  // Queries
  const fetchedRaterForm = useQuery({
    queryKey: ['getMasterRater'],
    queryFn: () =>
      getMasterRater({
        page: 1,
        userin: params.userid,
        scheduleid: params.id
      })
  });

  const inputRaterForm = useMutation({
    mutationFn: postRaterForm,
    onSuccess: () => {
      fetchedRaterForm.refetch();
      close();
      showNotification({
        type: 'success',
        message: 'Rater Form Submitted'
      });
      history.push({
        pathname: '/management/rater-form'
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleSubmit = (payload) => {
    const payloadMod = {
      ...payload,
      scheduleRaterID: params.id,
      userID: params.userid,
      userIn: params.userid
    };
    setDataPayload(payloadMod);
    open();
  };

  const handleConfirmSubmit = () => {
    inputRaterForm.mutate(dataPayload);
  };

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="RATER Form Input"
        itemList={[
          {
            title: 'RATER',
            href: '#',
            icon: <Unicons.UilFileCopyAlt size={16} />
          },
          {
            title: 'RATER Form',
            href: '/principal/rater-form'
          },
          {
            title: 'RATER Form Input',
            href: '/principal/rater-form/input'
          }
        ]}
      />

      <RaterInputForm
        questions={fetchedRaterForm?.data?.data?.data}
        onSubmit={handleSubmit}
        type="rater"
      />

      <ModalConfirmation
        isVisible={opened}
        onCancel={() => close()}
        onConfirm={() => handleConfirmSubmit()}
      />
    </AdminLayout>
  );
};

export default AdminRaterFormInputPage;
